<template>
  <!-- <Dialog :modal="true" v-model:visible="showIOLDialogvar" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
        :style="{ width: '75vw' }" header="IOL Allocation" @after-hide="IsClear"> -->
  <div class="overall-bg pb-0">
    <b-container class="container-class">
      <b-row>
        <b-col>
          <BackToMasters :goback="$router.back"></BackToMasters>
        </b-col>
      </b-row>
    </b-container>
  </div>

  <div class="overall-bg pt-0 mt-5">
    <b-container class="container-class">
      <b-row>
        <b-col class="border">
          <div class="field w-50">
            <label>UIN Number</label>
            <AutoCompleteCustom v-model="datamodel.uinnumber" :items="datamodel.UINOption" @keydown="LoadUINNumber"
              class="autoItem" @item-select="UINNumberSelect" name="uinnumber" id="uinnumber" />
          </div>

          <div class="patientdetailspopupcard" v-if="PatientDetails.UIN">
            <!-- <div class="patientdetailspopupcard"> -->
            <div class="d-flex justify-space-between">
              <p v-if="PatientDetails.UIN">
                UIN: <span>{{ PatientDetails.UIN }}</span>
              </p>
              <!-- <p v-if="PatientDetails.UIN"> Brand: <span></span></p>
              <p v-if="PatientDetails.UIN">Model: <span></span></p> -->
              <p v-if="PatientDetails.UIN">
                Lens Power: <span>{{ PatientDetails.IolPower }}</span>
              </p>
            </div>
            <div class="firstdiv">
              <div>
                <p v-if="PatientDetails.UIN">
                  MRN no: <span>{{ PatientDetails.MRNNo }}</span>
                </p>
                <p v-if="PatientDetails.UIN">
                  Name: <span>{{ PatientDetails.PatientName }}</span>
                </p>
              </div>
              <div>
                <p v-if="PatientDetails.UIN">
                  Surgery Name: <span>{{ PatientDetails.Surgery }}</span>
                </p>
                <p v-if="PatientDetails.UIN">
                  Patient Type: <span>{{ PatientDetails.PatientType }}</span>
                </p>
                <p v-if="PatientDetails.UIN">
                  Treatment Type:
                  <span>{{ PatientDetails.treatmentType }}</span>
                </p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="border">
          <SkeletonTableLoader v-if="loading" :columns="iolheaders" :loading="iolLoading" />

          <NormalTableview v-else v-model:value="iolitems" :paginator="true" class="p-datatable-gridlines" :rows="10"
            :rowHover="true" :loading="loading" responsiveLayout="scroll" :columns="iolheaders" dataKey="RowNumber"
            :selectionMode="false" :seriaNlumber="true">
            <template v-slot:ItemName="{ data }">
              <span>
                {{ data.ItemName }}
              </span>
              <span class="spantxt">
                {{ data.BarCode }}
              </span>
            </template>
            <template v-slot:Brandmodelsize="{ data }">
              <span class="spantxt">
                <template v-if="data.BrandName">{{
                  data.BrandName
                }}</template>
                <template v-if="data.BrandName && data.ModelNumberName"> / </template>
                <template v-if="data.ModelNumberName">{{
                  data.ModelNumberName
                }}</template>
                <template v-if="
                  (data.BrandName || data.ModelNumberName) &&
                  data.SizeName
                "> / </template>
                <template v-if="data.SizeName">{{
                  data.SizeName
                }}</template>
              </span>
            </template>
          </NormalTableview>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="3" md="4" sm="6" cols="12" class="field" v-show="QueryStringValue.Param != 'pending'">
          <CustomDropDown label="OT name" :items="DataObj.OTDeptOption" name="OT" v-model="DataObj.OTDeptId"
            @change="OTDeptOnChange" :rules="{ required: true }" :required-icon="true"
            :disabled="DataObj.StoreDropDownDisabled" :show-clear="true" />
        </b-col>
        <b-col lg="3" md="4" sm="6" cols="12" class="field" v-show="QueryStringValue.Param != 'pending'">
          <CustomDropDown label="OT Received name" :items="DataObj.OTSisterOption" name="OTSister"
            v-model="DataObj.OTSisterId" @change="OTSisterOnChange" :rules="{ required: true }" :required-icon="true" />
        </b-col>
        <!-- <b-col lg="3" md="4" sm="6" cols="12" class="field" v-if="showitems != 'updateconsumption'">
                    <TextField label="Barcode" name="Barcode" v-model="datamodel.bracode" :rules="{ required: true }"
                        :required-icon="true" />
                </b-col> -->
        <b-col lg="3" md="4" sm="6" cols="8" class="field" v-if="QueryStringValue.Param != 'updateconsumption'">
          <div v-if="DataObj.ScanActive == 'activebarcodebg'">
            <TextField label="Item barcode" v-model="DataObj.Item" type="text" :rules="{}" placeholder="Choose Item"
              clearable name="Item" id="Item" @keyupenter="onScanEnter" :required-icon="true" :disabled="QueryStringValue.Param == 'pending'
                ? false
                : DataObj.ItemFieldDisabled
                " />
          </div>
          <div v-else>
            <label>Item name<span class="red"> *</span></label>
            <AutoCompleteCustom v-model="DataObj.Item" :items="DataObj.ItemOption" @keydown="LoadItem" class="autoItem"
              @item-select="onScanEnter" name="ItemName" id="ItemName" :disabled="QueryStringValue.Param == 'pending'
                ? false
                : DataObj.ItemFieldDisabled
                " />
          </div>
        </b-col>
        <b-col lg="1" md="1" sm="1" cols="1" v-if="QueryStringValue.Param != 'updateconsumption'" class="">
          <div :class="DataObj.ScanActive">
            <i class="pi pi-qrcode" @click="
              DataObj.ScanActive == 'barcodebg'
                ? (DataObj.ScanActive = 'activebarcodebg')
                : (DataObj.ScanActive = 'barcodebg')
              "></i>
          </div>
        </b-col>

        <b-col lg="2" md="3" sm="4" cols="6" v-if="QueryStringValue.Param != 'updateconsumption'" class="mt-4">
          <!-- <AddButton class=" btn-class-name" btnname="Add" @click="AddItem" /> -->
          <Footer CancelLabel="Clear" label="Add" @cancel="ObjectClear" @save="AddItem" />
        </b-col>
      </b-row>

      <b-row v-if="QueryStringValue.Param != 'updateconsumption'" class="mt-4 mb-4">
        <!-- <b-col lg="12" md="12" sm="12" cols="12">
                    <h4 class="compo-heading mb-4">Scanned Item</h4>
                </b-col> -->
        <b-col lg="12" md="12" sm="12" cols="12">
          <!-- {{ items }} -->
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <NormalTableview v-model:value="items" :paginator="true" class="p-datatable-gridlines" :rows="10"
              :rowHover="true" :loading="loading" responsiveLayout="scroll" :columns="headers" dataKey="RowNumber"
              :selectionMode="false" :seriaNlumber="true">
            </NormalTableview>
          </div>
        </b-col>
        <b-col>
          <p class="alert_txt">
            <i class="pi pi-exclamation-triangle"></i>This Lens cannot be
            allocated, because the Pateint type is insurance and scanned lens is
            free
          </p>
          <p class="alert_txt">
            <i class="pi pi-exclamation-triangle"></i>There are three Additional
            lenses which going to be expire soon: LOT07897, LOT96969, and
            LOT8588 all having the same diopter size
          </p>
          <p class="alert_txt">
            <i class="pi pi-exclamation-triangle"></i>Scannes lens power doesn't
            match with patient required lens
          </p>
          <p class="alert_txt">
            <i class="pi pi-exclamation-triangle"></i>The Scanned Lens aare
            Expired
          </p>
        </b-col>
      </b-row>
      <b-row v-if="QueryStringValue.Param == 'allocate'">
        <b-col lg="12" md="12" sm="12" cols="12">
          <h4 class="compo-heading mb-4">Allocated Item</h4>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12">
          <!-- {{ allocateditems }} -->
          <NormalTableview v-model:value="allocateditems" :paginator="true" class="p-datatable-gridlines" :rows="10"
            :rowHover="true" :loading="loading" responsiveLayout="scroll" :columns="allocatedheaders"
            dataKey="RowNumber" :selectionMode="false" :seriaNlumber="true">
          </NormalTableview>
        </b-col>
      </b-row>
      <b-row v-if="QueryStringValue.Param == 'updateconsumption'">
        <b-col lg="12" md="12" sm="12" cols="12">
          <h4 class="compo-heading mb-4">Issued Item</h4>
        </b-col>
        <b-col lg="12" md="12" sm="12" cols="12">
          <!-- {{ issueditems }} -->
          <NormalTableview v-model:value="issueditems" :paginator="true" class="p-datatable-gridlines" :rows="10"
            :rowHover="true" :loading="loading" responsiveLayout="scroll" :columns="issueheaders" dataKey="RowNumber"
            :selectionMode="false" :seriaNlumber="true">
            <template v-slot:ConsumptionStatus="{ data }">
              <div class="label-d-none tablefield mb-0" @click="filterReason(data)">
                <CustomDropDown :items="data.ConsumptionReasonOption" v-model="data.StockReasonId" :showClear="true"
                  @change="ReasonOnChange(data)">
                </CustomDropDown>
              </div>
            </template>
          </NormalTableview>
        </b-col>
      </b-row>
      <b-row v-if="
        QueryStringValue.Param == 'pending' ||
        QueryStringValue.Param == 'updateconsumption'
      ">
        <b-col class="field">
          <TextArea label="Remarks" name="Remarks" v-model="ObjIOLAllocation.Remarks" :rows="4" />
        </b-col>
      </b-row>
      <b-row v-if="
        QueryStringValue.Param != 'issue' &&
        QueryStringValue.Param != 'issuestandbylens'
      ">
        <Footer @cancel="IsClear" :label="submitlabel" @save="IsSubmit" />
      </b-row>
    </b-container>
  </div>

  <Dialog v-model:visible="RemarksPopUpObj.visible" modal :header="RemarksPopUpObj.PopUpHeaderName" :breakpoints="{
    '1980px': '55vw',
    '1440px': '60vw',
    '960px': '70vw',
    '640px': '90vw',
  }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <p class="alert_txt">
              <i class="pi pi-exclamation-triangle"></i>{{ RemarksPopUpObj.Content }}
            </p>
            <TextArea :name="RemarksPopUpObj.TextAreaName" :label="RemarksPopUpObj.TextAreaName"
              :rules="{ required: false }" :id="RemarksPopUpObj.TextAreaName" v-model="RemarksPopUpObj.Remarks" />
            <Footer class="p-3" CancelLabel="Clear" label="Add" @cancel="CancelRemarks" @save="AddRemarks" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Dialog v-model:visible="chkAllocationPopUpObj.visible" modal :header="chkAllocationPopUpObj.PopUpHeaderName"
    :breakpoints="{
      '1980px': '55vw',
      '1440px': '60vw',
      '960px': '70vw',
      '640px': '90vw',
    }" class="overall-bg">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <p class="alert_txt">
              <i class="pi pi-exclamation-triangle"></i>{{ chkAllocationPopUpObj.Content }}
            </p>
            <Footer class="p-3" CancelLabel="Clear" label="Add" @cancel="CancelAllocation" @save="AddAllocation" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  watch,
  onMounted,
  computed,
  watchEffect,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "primevue/usetoast";

import moment from "moment";
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";

import TextField from "../../../../../components/FormComponents/TextInput.vue";
import TextArea from "../../../../../components/FormComponents/TextArea.vue";
import AutoCompleteCustom from "../../../../../components/FormComponents/AutoComplete.vue";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import CustomDropDown from "../../../../../components/FormComponents/Dropdown.vue";
import NormalTableview from "../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import AddButton from "../../../../../components/GeneralButtons/AddButton.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";

import PatientIssueService from "../../../../../modules/Inventory/Service/PatientIssueService";
import { FailedToStartTransportError } from "@microsoft/signalr/dist/esm/Errors";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    TextField,
    Tableview,
    NormalTableview,
    Footer,
    CustomDropDown,
    TextArea,
    AutoCompleteCustom,
    AddButton,
    SkeletonTableLoader,
    BackToMasters,
  },

  props: {
    showIOLDialog: {
      type: Boolean,
      default: false,
    },

    showitems: {
      type: String,
      default: "",
    },

    PatientDetails: {
      type: Object,
      default: {},
    },
  },

  setup(props, { emit }) {
    const route = useRoute();
    const toast = useToast();

    let QueryStringValue = ref(route.query);

    let CurrentDate = new Date().toISOString().slice(0, 10);
    const showIOLDialogvar = ref(props.showIOLDialog);
    const submitlabel = ref("");
    const iolitems = ref([]);

    const items = ref<ItemList[]>([]);
    const allocateditems = ref<AllocatedItemList[]>([]);
    const issueditems = ref<IssuedItemList[]>([]);
    let HiddenItems: any = ref([]);
    let itemsCopy: any = ref([]);
    let ItemDetailArr: any = [];
    let ScannedIttemArr: any = ref([]);

    let showitemsvar = ref(props.showitems);
    const loading = ref(false);
    const iolLoading = ref(false);
    //Local storage value
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    //

    const SelectOption = ref({
      otoption: ref([]),
    });

    const RemarksPopUpObj = ref({
      visible: false,
      PopUpHeaderName: "Remarks",
      Content: "Scannes lens power doesn't match with patient required lens",
      TextAreaName: "Remarks",
      Remarks: "",
    });

    const chkAllocationPopUpObj = ref({
      visible: false,
      PopUpHeaderName: "Already Allocated",
      Content: "",
      TextAreaName: "Remarks",
      Remarks: "",
    });

    interface UIN {
      uin: string;
      mrno: string;
      ipano: string;
      patientName: string;
      nextOfKin: string;
      eye: string;
      surgery: string;
      lens: string;
      admissionDate: string;
      siteId: number | 0;
      patientType: string;
      iolPower: string;
      paymentType: string;
      corporateName: string;
      treatmentType: string;

      label: string;
      value: string;
    }

    const datamodel = ref<{
      uinnumber: string;
      UINOption: UIN[];
      GetAdmittedPatientSurgeryListArray: UIN[];
    }>({
      uinnumber: "",
      UINOption: [],
      GetAdmittedPatientSurgeryListArray: [],
    });

    interface PatientDetails {
      UIN: string;
      MRNNo: string;
      PatientName: string;
      NextOfKin: string;
      Eye: string;
      Surgery: string;
      Lense: string;
      ExpectedAdmissionDate: Date | null;
      SiteId: number | 0;
      PatientType: string;
      IolPower: string;
      corporateName: string;
      Clinic: string;
      treatmentType: string;
      StockOutId: number | 0;
      StockOutDocNo: string;
      StockInId: number | 0;
      StockInDocNo: string;
    }

    const PatientDetails = ref<PatientDetails>({
      UIN: "",
      MRNNo: "",
      PatientName: "",
      NextOfKin: "",
      Eye: "",
      Surgery: "",
      Lense: "",
      ExpectedAdmissionDate: null,
      SiteId: 0,
      PatientType: "",
      IolPower: "",
      corporateName: "",
      Clinic: "",
      treatmentType: "",
      StockOutId: 0,
      StockOutDocNo: "",
      StockInId: 0,
      StockInDocNo: "",
    });

    interface IOLAllocation {
      Id: number;
      uin: string;
      mrno: string;
      patientName: string;
      nextOfKin: string;
      eye: string;
      surgery: string;
      lens: string;
      expectedAdmissionDate: string;
      siteId: number | 0;
      patientType: string;
      iolPower: string;
      ItemId: number | null;
      Brand: number | 0;
      ModelNumber: number | 0;
      Size: number | 0;
      Qty: number | 0;
      BarCodeNo: number | 0;
      BarCode: string;
      BatchNo: string;
      ExpiryDate: string;
      IsDraft: number | 0;
      Remarks: string;
      CreatedBy: number | 0;
      CreatedAt: string;
      ModifiedBy: number | 0;
      ModifiedAt: string;
      HospitalId: number | 0;
      BranchId: number | 0;
      StoreBrMapId: number | 0;
      StoreId: number | 0;
    }

    const ObjIOLAllocation = ref<IOLAllocation>({
      Id: 0,
      uin: "",
      mrno: "",
      patientName: "",
      nextOfKin: "",
      eye: "",
      surgery: "",
      lens: "",
      expectedAdmissionDate: "",
      siteId: 0,
      patientType: "",
      iolPower: "",
      ItemId: null,
      Brand: 0,
      ModelNumber: 0,
      Size: 0,
      Qty: 0,
      BarCodeNo: 0,
      BarCode: "",
      BatchNo: "",
      ExpiryDate: "",
      IsDraft: 0,
      Remarks: "",
      CreatedBy: 0,
      CreatedAt: CurrentDate,
      ModifiedBy: 0,
      ModifiedAt: CurrentDate,
      HospitalId: 0,
      BranchId: 0,
      StoreBrMapId: 0,
      StoreId: 0,
    });

    const CreateIssueObj = ref({
      Id: 0,
      DocType: "",
      DocNo: "",
      DocDate: CurrentDate,
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      SupplierId: 0,
      DcNo: "",
      DcDate: CurrentDate,
      InvoiceNo: "",
      InvoiceDate: CurrentDate,
      InwardNo: "",
      InwardDate: CurrentDate,
      Type: "",
      Status: "",
      AuthorizedStatus: false,
      CancelReason: "",
      Cancelled: false,
      RefId: 0,
      RefNo: "",
      CreatedBy: 0,
      CreatedAt: CurrentDate,
      ModifiedBy: 0,
      ModifiedAt: CurrentDate,
      Remarks: "",
      SubDetailsAmount: 0,
      TaxAmount: 0,
      DiscountAmount: 0,
      Amount: 0,
      ClosedReason: "",
      Closed: false,
      Subject: "",
      HospitalId: 0,
      BranchId: 0,
      GrnPaymentType: "",
      CrNoteAmt: 0,
      DueAmount: 0,
      PatientId: "",
      PatientName: "",
      VisitId: 0,
      TempPatientId: 0,
      TotalTransportCharges: 0,
      TotalServiceCharges: 0,
      TotalOtherCharges: 0,
      NetAmount: 0,
      IsActive: false,
      EntityId: 0,
      EntityOperationId: 0,
      TotalQty: 0,
      IsApproved: 1,
      GRNTransportationCharges: 0,
      GRNOtherCharges: 0,
      GRNDiscount: 0,
      DCType: 0,
      GRNTransportationTax: 0,
      GRNFreightCharges: 0,
      GRNFreightTax: 0,
      SGSTTaxAmount: 0,
      CGSTTaxAmount: 0,
      IGSTTaxAmount: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      StoreBrMapId: 0,
      RoundOff: "",
      RequestId: 0,
      RequestNo: "",
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsDraft: 0,
      DeptRoleId: 0,

      StockOutDetailList: [],
      StockInDetailList: [],
    });

    const IssueReturnObj = ref({
      Id: 0,
      DocType: "",
      DocNo: "",
      DocDate: CurrentDate,
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      SupplierId: 0,
      DcNo: "",
      DcDate: CurrentDate,
      InvoiceNo: "",
      InvoiceDate: CurrentDate,
      InwardNo: "",
      InwardDate: CurrentDate,
      Type: "",
      Status: "",
      AuthorizedStatus: false,
      CancelReason: "",
      Cancelled: false,
      RefId: 0,
      RefNo: "",
      CreatedBy: 0,
      CreatedAt: CurrentDate,
      ModifiedBy: 0,
      ModifiedAt: CurrentDate,
      Remarks: "",
      SubDetailsAmount: 0,
      TaxAmount: 0,
      DiscountAmount: 0,
      Amount: 0,
      ClosedReason: "",
      Closed: false,
      Subject: "",
      HospitalId: 0,
      BranchId: 0,
      GrnPaymentType: "",
      CrNoteAmt: 0,
      DueAmount: 0,
      PatientId: "",
      PatientName: "",
      VisitId: 0,
      TempPatientId: 0,
      TotalTransportCharges: 0,
      TotalServiceCharges: 0,
      TotalOtherCharges: 0,
      NetAmount: 0,
      IsActive: false,
      EntityId: 0,
      EntityOperationId: 0,
      TotalQty: 0,
      IsApproved: 1,
      GRNTransportationCharges: 0,
      GRNOtherCharges: 0,
      GRNDiscount: 0,
      DCType: 0,
      GRNTransportationTax: 0,
      GRNFreightCharges: 0,
      GRNFreightTax: 0,
      SGSTTaxAmount: 0,
      CGSTTaxAmount: 0,
      IGSTTaxAmount: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      StoreBrMapId: 0,
      RoundOff: "",
      RequestId: 0,
      RequestNo: "",
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsDraft: 0,
      DeptRoleId: 0,

      StockOutDetailList: [],
    });

    interface Item {
      BarCodeNo: number;
      SizeName: string;
    }

    interface OTDeptOption {
      StoreId: number;
      StoreName: string;
      BranchId: number;
      StoreBranchMapId: number;
    }

    interface OTSisterOption {
      ID: number;
      UserName: string;
    }

    interface ConsumptionReasonOption { }

    const DataObj = ref<{
      Item: any;
      ItemOption: Item[];
      ScanActive: string;

      OTDeptOption: OTDeptOption[];
      OTDeptId: any;

      OTSisterOption: OTSisterOption[];
      OTSisterId: any;
      ToStoreUserName: string;

      ToStoreId: number;
      ToStoreName: string;
      ToStoreBranchId: number;
      ToStoreBrMapId: number;
      ItemFieldDisabled: boolean;
      StoreDropDownDisabled: boolean;
      ConsumptionReasonOption: ConsumptionReasonOption[];
      BarCode: string;
    }>({
      Item: ref(),
      ItemOption: [],
      ScanActive: "activebarcodebg",

      OTDeptOption: [],
      OTDeptId: null,

      OTSisterOption: [],
      OTSisterId: null,
      ToStoreUserName: "",

      ToStoreId: 0,
      ToStoreName: "",
      ToStoreBranchId: 0,
      ToStoreBrMapId: 0,
      ItemFieldDisabled: true,
      StoreDropDownDisabled: false,
      ConsumptionReasonOption: [],
      BarCode: "",
    });

    interface CommonRequest {
      StoreId: number | 0;
      BranchId: number | 0;
      HospitalId: number | 0;
      ToStoreId: number | 0;
    }

    const CommonRequestObj = ref<CommonRequest>({
      StoreId: Number(QueryStringValue.value.StoreId),
      BranchId: Number(QueryStringValue.value.BranchId),
      HospitalId: usersData.OrganizationId,
      ToStoreId: 0,
    });

    interface obj {
      Date: string;
      SiteId: number | 0;
    }

    onMounted(() => {
      debugger;
      ReadyFunction();
    });

    const ReadyFunction = async () => {
      debugger;
      await submitbuttonName();

      if (
        QueryStringValue.value.Param == "allocate" ||
        QueryStringValue.value.Param == "issue" ||
        QueryStringValue.value.Param == "issuestandbylens" ||
        QueryStringValue.value.Param == "updateconsumption"
      ) {
        await LoadOTDepartment();
        if (QueryStringValue.value.Param == "updateconsumption") {
          await LoadReasons();
        }
      }

      if ((QueryStringValue.value.Param = "issue")) {
        // await GetAdmittedPatientSurgeryList();
      }

      if ((QueryStringValue.value.Param = "issuestandbylens")) {
        let data = {
          StockOutId: QueryStringValue.value.StockOutId,
          Date: QueryStringValue.value.Date,
        };

        await GetIssuedItemsByStockOutId(data);
      }
    };

    const submitbuttonName = () => {
      debugger;
      if (QueryStringValue.value.Param === "pending") {
        submitlabel.value = "Allocate";
      } else if (QueryStringValue.value.Param === "allocate") {
        submitlabel.value = "Issue";
      } else if (QueryStringValue.value.Param === "issuestandbylens") {
        submitlabel.value = "Issue as Standby";
      } else if (QueryStringValue.value.Param === "updateconsumption") {
        submitlabel.value = "Update";
      } else if (QueryStringValue.value.Param === "issue") {
        submitlabel.value = "Issue";
      }
    };

    const Obj = ref<obj>({
      // Date: "2025-03-03",
      Date: moment().format("YYYY-MM-DD"),
      SiteId: Number(QueryStringValue.value.SiteId) || 1,
    });

    const GetAdmittedPatientSurgeryList = async (): Promise<void> => {
      debugger;
      try {
        // const response = await PatientIssueService.GetAdmittedPatientSurgeryList(Obj.value);
        // datamodel.value.GetAdmittedPatientSurgeryListArray = response["result"];
      } catch (error) {
        console.error("Error loading admited patient list:", error);
      }
    };

    const LoadUINNumber = async () => {
      debugger;
      try {
        if (datamodel.value.uinnumber) {
          // const response = await PatientIssueService.GetAdmittedPatientSurgeryList(Obj.value);
          // const response = await PatientIssueService.GetSurgeryListMMS(
          //   Obj.value
          // );
          const response =
            await PatientIssueService.GetExpectedPatientSurgeryList(Obj.value);

          datamodel.value.GetAdmittedPatientSurgeryListArray =
            response["result"];

          let SearchText = datamodel.value.uinnumber;

          let regex = new RegExp(SearchText, "i");

          datamodel.value.UINOption =
            datamodel.value.GetAdmittedPatientSurgeryListArray.filter(
              (x) => regex.test(x.uin) || regex.test(x.patientName)
            ).map((y) => {
              y.label = y["uin"] + " - " + y["patientName"];
              y.value = y["uin"];
              return y;
            });
        }
      } catch (error) {
        console.error("Error loading admited patient list:", error);
      }
    };

    const UINNumberSelect = (event) => {
      debugger;

      let PatientObj =
        datamodel.value.GetAdmittedPatientSurgeryListArray.filter(
          (x) => x.uin == event.value.uin
        );

      GetPatientDetails(PatientObj[0]);

      datamodel.value.uinnumber = "";

      if (
        DataObj.value.OTDeptId &&
        DataObj.value.OTSisterId &&
        PatientDetails.value.UIN
      ) {
        DataObj.value.ItemFieldDisabled = false;
      } else {
        DataObj.value.ItemFieldDisabled = true;
      }
    };

    // watch(
    //     () => [props.showitems, props.PatientDetails],
    //     ([newShowitems, newPatientDetails]) => {
    //         debugger;
    //         if (newShowitems) {
    //             if (newShowitems === 'pending') {
    //                 submitlabel.value = 'Allocate';
    //             } else if (newShowitems === 'allocate') {
    //                 submitlabel.value = 'Issue';
    //             } else if (newShowitems === 'issuestandbylens') {
    //                 submitlabel.value = 'Issue as Standby';
    //             } else if (newShowitems === 'updateconsumption') {
    //                 submitlabel.value = 'Update';
    //             } else if (newShowitems === 'issue') {
    //                 submitlabel.value = 'Issue';
    //             }
    //         }

    //         if (newPatientDetails) {
    //             if (newShowitems == "allocate") {
    //                 const patientDetailsArray = Array.isArray(newPatientDetails) ? newPatientDetails : [newPatientDetails];
    //                 allocateditems.value = [
    //                     ...allocateditems.value,
    //                     ...patientDetailsArray.map((x) => {
    //                         x.ItemId = x.Id;
    //                         x.Qty = 1;
    //                         return x;
    //                     })
    //                 ];

    //                 GetIssuedItemsByStockOutId(newPatientDetails)
    //             }
    //             else if (newShowitems == "issue") {
    //                 GetIssuedItemsByStockOutId(newPatientDetails)
    //             }
    //             else if (newShowitems == "issuestandbylens" || newShowitems == "updateconsumption") {
    //                 GetIssuedItemsByStockOutId(newPatientDetails)
    //             }

    //             if (newShowitems == "allocate" || newShowitems == "issue" || newShowitems == "issuestandbylens" || newShowitems == "updateconsumption") {
    //                 LoadOTDepartment();
    //                 if (newShowitems == "updateconsumption") {
    //                     LoadReasons();
    //                 }
    //             }

    //             GetPatientDetails(newPatientDetails);
    //         }
    //     },
    //     { immediate: true }
    // );

    async function GetPatientDetails(Obj) {
      debugger;
      PatientDetails.value.UIN = Obj.uin;
      PatientDetails.value.MRNNo = Obj.mrno;
      PatientDetails.value.PatientName = Obj.patientName;
      (PatientDetails.value.NextOfKin = Obj.nextOfKin),
        (PatientDetails.value.Eye = Obj.eye),
        (PatientDetails.value.Surgery = Obj.surgery);
      (PatientDetails.value.Lense = Obj.eye),
        (PatientDetails.value.ExpectedAdmissionDate =
          Obj.date || Obj.expectedAdmissionDate),
        (PatientDetails.value.SiteId = Obj.siteId),
        (PatientDetails.value.PatientType = Obj.patientType);
      PatientDetails.value.IolPower = Obj.iolPower;

      PatientDetails.value.Surgery = Obj.surgery;
      PatientDetails.value.Clinic = Obj.clinic;
      PatientDetails.value.treatmentType = Obj.treatmentType;

      PatientDetails.value.StockOutId = Obj.StockOutId || 0;
      PatientDetails.value.StockInId = Obj.StockInId || 0;

      await GetIOLItemsBySurgeryName();
    }

    async function LoadOTDepartment() {
      debugger;
      try {
        const response = await PatientIssueService.GetDeptStoresByStoreId(
          CommonRequestObj.value
        );

        DataObj.value.OTDeptOption = response["result"].map((item) => {
          item.name = item.StoreName + "-" + item.BranchName;
          item.value = item.StoreId;
          return item;
        });

        if (DataObj.value.OTDeptOption.length == 1) {
          DataObj.value.OTDeptId = DataObj.value.OTDeptOption[0].StoreId;
          OTDeptOnChange();
        }
      } catch (error) {
        alert(error);
      }
    }

    const OTDeptOnChange = () => {
      debugger;

      let OTDeptArray = DataObj.value.OTDeptOption.filter(
        (x) => x.StoreId == DataObj.value.OTDeptId
      );

      DataObj.value.ToStoreId = OTDeptArray[0].StoreId;
      DataObj.value.ToStoreName = OTDeptArray[0].StoreName;
      DataObj.value.ToStoreBranchId = OTDeptArray[0].BranchId;
      DataObj.value.ToStoreBrMapId = OTDeptArray[0].StoreBranchMapId;
      LoadOTSister();
    };

    async function LoadOTSister() {
      debugger;
      try {
        CommonRequestObj.value.ToStoreId = DataObj.value.ToStoreId;

        const response = await PatientIssueService.GetUserByStoreId(
          CommonRequestObj.value
        );

        DataObj.value.OTSisterOption = response["result"].map((item) => {
          item.name = item.UserName;
          item.value = item.ID;
          return item;
        });
      } catch (error) {
        alert(error);
      }
    }

    const OTSisterOnChange = () => {
      debugger;
      if (DataObj.value.OTSisterId) {
        let OTSisterArray = DataObj.value.OTSisterOption.filter(
          (x) => x.ID == DataObj.value.OTSisterId
        );

        DataObj.value.ToStoreUserName = OTSisterArray[0].UserName;

        if (PatientDetails.value.UIN) {
          DataObj.value.ItemFieldDisabled = false;
        } else {
          DataObj.value.ItemFieldDisabled = true;
          alert("Select patient UIN number");
        }
      } else {
        DataObj.value.ItemFieldDisabled = true;
      }
    };

    async function LoadReasons() {
      debugger;
      try {
        let obj = ref({
          HospitalId: usersData.OrganizationId,
        });

        const response = await PatientIssueService.GetIOLReturnReason(
          obj.value
        );

        response["result"].unshift({
          Id: 0,
          ReasonName: "Consumed",
          IsActive: true,
          Type: 10,
          HospitalId: usersData.OrganizationId,
        });

        DataObj.value.ConsumptionReasonOption = response["result"].map(
          (item) => {
            item.name = item.ReasonName;
            item.value = item.Id;
            return item;
          }
        );
      } catch (error) {
        alert(error);
      }
    }

    function filterReason(data) {
      debugger;
      data.ConsumptionReasonOption = DataObj.value.ConsumptionReasonOption;

      if (data.ConsumptionReasonOption.length == 0) {
        data.ConsumptionReasonOption = DataObj.value.ConsumptionReasonOption;
      }
    }

    function ReasonOnChange(data) {
      debugger;

      let RemarksReason = data.ConsumptionReasonOption.filter(
        (x) => x.Id == data.StockReasonId
      );

      data.Remarks = RemarksReason[0].ReasonName;
    }

    async function GetIssuedItemsByStockOutId(data) {
      debugger;
      try {
        loading.value = true;
        // let Obj = { PatientId: data.uin }
        let Obj = { StockOutId: data.StockOutId, Date: data.Date };

        const response = await PatientIssueService.GetIssuedItemsByStockOutId(
          Obj
        );

        if (response["result"].length > 0) {
          response["result"] = response["result"].map((x) => {
            x.StockOutId = x.StockOutId;
            x.StockOutDetailId = x.StockOutDetailId;
            x.ItemExpiryDate = x.ExpiryDate;
            x.Batchno = x.BatchNo;

            if (QueryStringValue.value.Param == "updateconsumption") {
              x.Remarks = "";
            }
            return x;
          });

          items.value = response["result"];

          DataObj.value.OTDeptId = response["result"][0].ToStoreId;
          OTDeptOnChange();
          DataObj.value.StoreDropDownDisabled = true;

          issueditems.value = response["result"];
        }
        loading.value = false;
      } catch (error) {
        console.error("Error loading issued items:", error);
        loading.value = false;
      }
    }

    async function GetIOLIssueByStockOutId(data) {
      debugger;
      try {
        let Obj = { StockOutId: data.StockOutId };

        const response = await PatientIssueService.GetIOLIssueByStockOutId(Obj);

        response["result"] = response["result"].map((x) => {
          x.StockOutId = x.StockOutId;
          x.StockOutDetailId = x.StockOutDetailId;

          x.ItemExpiryDate = x.ExpiryDate;

          if (QueryStringValue.value.Param == "updateconsumption") {
            x.Remarks = "";
          }
          return x;
        });

        items.value = response["result"];

        issueditems.value = response["result"];
      } catch (error) {
        console.error("Error loading issued items:", error);
      }
    }

    async function GetIOLItemsBySurgeryName() {
      debugger;
      iolLoading.value = true
      try {
        let GetObj = ref({
          FromStoreId: QueryStringValue.value.StoreId,
          ToStoreId: 0,
          Type: 1,
          FromStoreBrMapId: QueryStringValue.value.storebranchmapid,
          ToStoreBrMapId: 0,
          OrganizationId: usersData.OrganizationId,
          FromStoreBranchId: QueryStringValue.value.BranchId,
          ToStoreBranchId: 0,
          Surgery: PatientDetails.value.Surgery,
          TreatmentType: PatientDetails.value.treatmentType,
        });

        const response = await PatientIssueService.GetIOLItemsBySurgeryName(
          GetObj.value.FromStoreId,
          GetObj.value.ToStoreId,
          GetObj.value.Type,
          GetObj.value.FromStoreBrMapId,
          GetObj.value.ToStoreBrMapId,
          GetObj.value.OrganizationId,
          GetObj.value.FromStoreBranchId,
          GetObj.value.ToStoreBranchId,
          GetObj.value.Surgery || "",
          GetObj.value.TreatmentType || ""
        );

        if (response["result"].length > 0) {

          iolitems.value = response["result"]
            .filter(
              (x) =>

                x.ItemCategoryName == PatientDetails.value.treatmentType
            )
            .map((x: any) => {
              if (x.ExpiryDate == '01-01-1900') {
                x.ExpiryDate = "";
              }
              return x;
            });
        }
        iolLoading.value = false;

      } catch (error) {
        console.error("Error loading Items:", error);
        iolLoading.value = false;
      }
    };

    const LoadItem = async () => {
      debugger;
      try {
        let RequestObj = ref({
          FromStoreId: QueryStringValue.value.StoreId,
          ToStoreId: 0,
          Input: DataObj.value.Item,
          Type: 1,
          FromStoreBrMapId: QueryStringValue.value.storebranchmapid,
          ToStoreBrMapId: 0,
          OrganizationId: usersData.OrganizationId,
          FromStoreBranchId: QueryStringValue.value.BranchId,
          ToStoreBranchId: 0,
          Surgery: PatientDetails.value.Surgery,
          TreatmentType: PatientDetails.value.treatmentType,
        });

        const response = await PatientIssueService.GetIOLItemsByStoreId(
          RequestObj.value.FromStoreId,
          RequestObj.value.ToStoreId,
          RequestObj.value.Input,
          RequestObj.value.Type,
          RequestObj.value.FromStoreBrMapId,
          RequestObj.value.ToStoreBrMapId,
          RequestObj.value.OrganizationId,
          RequestObj.value.FromStoreBranchId,
          RequestObj.value.ToStoreBranchId,
          RequestObj.value.Surgery || "",
          RequestObj.value.TreatmentType || ""
        );

        if (response["result"].length > 0) {
          let SearchText = RequestObj.value.Input;
          let regex = new RegExp(SearchText, "i");

          DataObj.value.ItemOption.length = 0;

          DataObj.value.ItemOption = response["result"]
            .filter(
              (x) =>
                (regex.test(x.Name) ||
                  regex.test(x.BarCode)) &&
                x.ItemCategoryName == PatientDetails.value.treatmentType
            )
            .map((x: any) => {
              let label = `${x["Name"]}`;
              if (x["BrandName"]) {
                label += ` (Brand: ${x["BrandName"]}`;
              }
              if (x["ModelNumberName"]) {
                label += `, Model: ${x["ModelNumberName"]}`;
              }
              if (x["SizeName"]) {
                label += `, Size: ${x["SizeName"]}`;
              }
              if (x["Batchno"]) {
                label += `, BatchNo: ${x["Batchno"]}`;
              }

              if (
                x["BrandName"] ||
                x["ModelNumberName"] ||
                x["SizeName"] ||
                x["Batchno"]
              ) {
                label += `)`;
              }
              x.label = label;
              x.value = x["BarCode"];
              return x;
            });
        }
      } catch (error) {
        console.error("Error loading Items:", error);
      }
    };

    const onScanEnter = async (event) => {
      debugger;

      try {
        let RequestObj = ref({
          FromStoreId: QueryStringValue.value.StoreId,
          ToStoreId: 0,
          Input: DataObj.value.Item,
          Type: 1,
          FromStoreBrMapId: QueryStringValue.value.storebranchmapid,
          ToStoreBrMapId: 0,
          OrganizationId: usersData.OrganizationId,
          BranchId: QueryStringValue.value.BranchId,
          Surgery: PatientDetails.value.Surgery || "",
          TreatmentType: PatientDetails.value.treatmentType || "",
        });

        let Barcode =
          DataObj.value.ScanActive == "activebarcodebg"
            ? DataObj.value.Item
            : event.value.value;

        const response = await PatientIssueService.GetIOLItemsByBarCode(
          RequestObj.value.FromStoreId,
          Barcode,
          RequestObj.value.OrganizationId,
          RequestObj.value.BranchId,
          RequestObj.value.Surgery,
          RequestObj.value.TreatmentType
        );
        console.log(response);

        if (response["result"].length > 0) {
          response["result"] = response["result"].filter(
            (x) => x.ItemCategoryName == PatientDetails.value.treatmentType
          );
        }

        if (response["result"].length > 0) {
          DataObj.value.Item = `${response["result"][0]["ItemName"]} - ${response["result"][0]["BarCode"]} (Brand: ${response["result"][0]["BrandName"]}, Model: ${response["result"][0]["ModelNumberName"]}, Size: ${response["result"][0]["SizeName"]}, BatchNo: ${response["result"][0]["Batchno"]})`;
          DataObj.value.BarCode = response["result"][0]["BarCode"];

          ScannedIttemArr.value = response["result"];
        }
      } catch (error) {
        console.log(error);
      }
    };

    const AddItem = async () => {
      debugger;
      if (PatientDetails.value.UIN) {
        let AdmittedDate = moment(
          PatientDetails.value.ExpectedAdmissionDate,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY");

        let response;
        response = await PatientIssueService.chkAlreadyAllocation(
          CommonRequestObj.value.HospitalId,
          CommonRequestObj.value.BranchId,
          CommonRequestObj.value.StoreId,
          PatientDetails.value.UIN,
          AdmittedDate,
          ScannedIttemArr.value[0].BarCode
        );
        let ItemBarcode = "";
        let AllocatedBarcode = "";
        let AllocatedItem = "";
        let AllocatedPatient = "";
        let AllocatedPatientName = "";
        let ItemUIN = "";
        let AllocationStatus = "";

        if (response.result.length > 0) {
          ItemBarcode = DataObj.value.Item["BarCode"];
          ItemUIN = PatientDetails.value.UIN;
          AllocatedBarcode = response.result[0]["BarCode"];
          AllocatedItem = response.result[0]["ItemName"];
          AllocatedPatient = response.result[0]["uin"];
          AllocatedPatientName = response.result[0]["patientName"];
          AllocationStatus = response.result[0]["AllocationStatus"];
        }

        if (AllocationStatus === "OtherBarcode") {
          chkAllocationPopUpObj.value.Content = `The selected UIN has another item allocated: ${AllocatedBarcode} (${AllocatedItem})`;
          chkAllocationPopUpObj.value.visible = true;
        } else if (AllocationStatus === "OtherPatient") {
          chkAllocationPopUpObj.value.Content = `Item already allocated for another UIN: ${AllocatedPatientName} (${AllocatedPatient})`;
          chkAllocationPopUpObj.value.visible = true;
        } else {
          if (
            PatientDetails.value.corporateName == null ||
            PatientDetails.value.corporateName == ""
          ) {
            ItemValidation();
          } else {
            if (ScannedIttemArr.value[0]["IsFreeItem"] == 1) {
              toast.add({
                severity: "warn",
                summary: "Warning",
                detail:
                  "This Lens cannot be allocated, because the Pateint type is insurance and scanned lens is free",
                life: 3000,
              });

              ItemAutoCompleteClear();

              return;
            } else {
              ItemValidation();
            }
          }
        }
      } else {
        toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "Select patient UIN number",
          life: 3000,
        });
      }
    };

    const ItemAutoCompleteClear = () => {
      DataObj.value.ItemOption.length = 0;
      DataObj.value.Item = "";
      RemarksPopUpObj.value.Remarks = "";
    };

    const ItemValidation = () => {
      debugger;

      const exists = items.value.some(
        (item) => item.BarCodeNo === ScannedIttemArr.value[0]["BarCodeNo"]
      );

      if (exists) {
        toast.add({
          severity: "warn",
          summary: "Exists",
          detail: "This BarCode Item already exists",
          life: 3000,
        });
      } else {
        let TodayDate = moment();

        if (
          ScannedIttemArr.value[0]["ItemExpiryDate"] == null ||
          moment(
            ScannedIttemArr.value[0]["ItemExpiryDate"],
            "DD-MM-YYYY"
          ).isAfter(TodayDate)
        ) {
          if (
            PatientDetails.value.IolPower ==
            (ScannedIttemArr.value[0]["SizeName"] || "")
          ) {
            if (
              items.value.length > 0 &&
              QueryStringValue.value.Param == "pending"
            ) {
              toast.add({
                severity: "info",
                summary: "Exist",
                detail: "Item already exists",
                life: 3000,
              });
            } else {
              if (QueryStringValue.value.Param == "pending") {
                items.value = ScannedIttemArr.value.map((x) => {
                  x.ItemId = x.Id;
                  x.Qty = 1;
                  return x;
                });
                CreateIssue();
              } else {
                itemsCopy.value = ScannedIttemArr.value.map((x) => {
                  x.ItemId = x.Id;
                  x.Qty = 1;
                  x.Remarks = "";
                  x.PatientId = PatientDetails.value.UIN;
                  x.PatientName = PatientDetails.value.PatientName;
                  x.ToStoreName = DataObj.value.ToStoreName;
                  x.ToStoreUserName = DataObj.value.ToStoreUserName;
                  x.PatientId = PatientDetails.value.UIN;
                  x.PatientName = PatientDetails.value.PatientName;
                  return x;
                });
                CreateIssue();
              }
            }
          } else {
            if (
              items.value.length > 0 &&
              QueryStringValue.value.Param == "pending"
            ) {
              toast.add({
                severity: "info",
                summary: "Exist",
                detail: "Item already exists",
                life: 3000,
              });
            } else {
              toast.add({
                severity: "info",
                summary: "Doesn't match",
                detail:
                  "Scannes lens power doesn't match with patient required lens",
                life: 3000,
              });

              HiddenItems.value = ScannedIttemArr.value;
              RemarksPopUpObj.value.visible = true;
            }
          }
        } else {
          toast.add({
            severity: "warn",
            summary: "Expired",
            detail: "The scanned lens are expired",
            life: 3000,
          });
        }
      }
      ItemAutoCompleteClear();
    };

    const AddRemarks = () => {
      debugger;
      if (QueryStringValue.value.Param == "pending") {
        console.log(HiddenItems.value);

        if (
          items.value.length > 0 &&
          QueryStringValue.value.Param == "pending"
        ) {
          toast.add({
            severity: "info",
            summary: "Exist",
            detail: "Item already exists",
            life: 3000,
          });
        } else {
          items.value = HiddenItems.value.map((x) => {
            x.ItemId = x.Id;
            x.Qty = 1;
            x.Remarks = RemarksPopUpObj.value.Remarks || "";
            return x;
          });

          CreateIssue();

          //ObjIOLAllocation.value.Remarks = RemarksPopUpObj.value.Remarks
        }
      } else if (
        QueryStringValue.value.Param == "allocate" ||
        QueryStringValue.value.Param == "issue" ||
        QueryStringValue.value.Param == "issuestandbylens"
      ) {
        itemsCopy.value = HiddenItems.value.map((x) => {
          x.StockOutDetailId = 0;
          x.ItemId = x.Id;
          x.Qty = 1;
          x.Remarks = RemarksPopUpObj.value.Remarks || "";
          x.PatientId = PatientDetails.value.UIN;
          x.PatientName = PatientDetails.value.PatientName;
          x.ToStoreName = DataObj.value.ToStoreName;
          x.ToStoreUserName = DataObj.value.ToStoreUserName;
          x.PatientId = PatientDetails.value.UIN;
          x.PatientName = PatientDetails.value.PatientName;
          return x;
        });

        CreateIssue();
      } else if (QueryStringValue.value.Param == "issuestandbylens") {
      }

      ItemAutoCompleteClear();
      RemarksPopUpObj.value.visible = false;
    };

    const CancelRemarks = () => {
      debugger;
      RemarksPopUpObj.value.visible = false;
    };

    const CancelAllocation = () => {
      chkAllocationPopUpObj.value.visible = false;
      RemarksPopUpObj.value.visible = false;
    };

    const AddAllocation = () => {
      chkAllocationPopUpObj.value.visible = false;
      RemarksPopUpObj.value.visible = true;
      if (
        PatientDetails.value.corporateName == null ||
        PatientDetails.value.corporateName == ""
      ) {
        ItemValidation();
      } else {
        if (ScannedIttemArr.value[0]["IsFreeItem"] == 1) {
          toast.add({
            severity: "warn",
            summary: "Warning",
            detail:
              "This Lens cannot be allocated, because the Pateint type is insurance and scanned lens is free",
            life: 3000,
          });

          ItemAutoCompleteClear();

          return;
        } else {
          ItemValidation();
        }
      }
    };

    const IsSubmit = async () => {
      debugger;
      // if (QueryStringValue.value.Param == "pending") {
      //     CreateAllocation();
      // }
      // else if (QueryStringValue.value.Param == "allocate" || QueryStringValue.value.Param == "issue" || QueryStringValue.value.Param == "issuestandbylens") {
      //     UpdateStockOutStockIn();
      // }
      // else if (QueryStringValue.value.Param == "updateconsumption") {
      UpdateConsumption();
      // }
    };

    const CreateAllocation = async () => {
      debugger;
      if (items.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Please Add the Item",
          detail: "",
          life: 3000,
        });

        return;
      } else {
        let message = "";

        ObjIOLAllocation.value.uin = PatientDetails.value.UIN;
        ObjIOLAllocation.value.mrno = PatientDetails.value.MRNNo;
        ObjIOLAllocation.value.patientName = PatientDetails.value.PatientName;
        ObjIOLAllocation.value.nextOfKin = PatientDetails.value.NextOfKin;
        ObjIOLAllocation.value.eye = PatientDetails.value.Eye;
        ObjIOLAllocation.value.surgery = PatientDetails.value.Surgery;
        ObjIOLAllocation.value.lens = PatientDetails.value.Lense;
        ObjIOLAllocation.value.expectedAdmissionDate = moment(
          PatientDetails.value.ExpectedAdmissionDate,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        ObjIOLAllocation.value.siteId = PatientDetails.value.SiteId;
        ObjIOLAllocation.value.patientType = PatientDetails.value.PatientType;
        ObjIOLAllocation.value.iolPower = PatientDetails.value.IolPower;

        for (let i = 0; i < items.value.length; i++) {
          ObjIOLAllocation.value.ItemId = items.value[i]["ItemId"] || 0;

          ObjIOLAllocation.value.Brand = items.value[i]["Brand"] || 0;
          ObjIOLAllocation.value.ModelNumber =
            items.value[i]["ModelNumber"] || 0;
          ObjIOLAllocation.value.Size = items.value[i]["Size"] || 0;
          ObjIOLAllocation.value.Qty = items.value[i]["Qty"];
          ObjIOLAllocation.value.BarCodeNo = items.value[i]["BarCodeNo"];
          ObjIOLAllocation.value.BarCode = items.value[i]["BarCode"] || "";
          ObjIOLAllocation.value.BatchNo = items.value[i]["BatchNo"] || "";

          if (items.value[i]["ItemExpiryDate"]) {
            ObjIOLAllocation.value.ExpiryDate = moment(
              items.value[i]["ItemExpiryDate"],
              "DD-MM-YYYY"
            ).format("YYYY-MM-DD");
          } else {
            ObjIOLAllocation.value.ExpiryDate = "1900-01-01";
          }
        }

        (ObjIOLAllocation.value.IsDraft = 0),
          (ObjIOLAllocation.value.Remarks =
            ObjIOLAllocation.value.Remarks || ""),
          (ObjIOLAllocation.value.CreatedBy = usersData.UserId),
          (ObjIOLAllocation.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          ));
        ObjIOLAllocation.value.ModifiedBy = 0;
        ObjIOLAllocation.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        ObjIOLAllocation.value.HospitalId = usersData.OrganizationId;
        ObjIOLAllocation.value.BranchId = Number(
          QueryStringValue.value.BranchId
        );
        ObjIOLAllocation.value.StoreBrMapId = Number(
          QueryStringValue.value.storebranchmapid
        );
        ObjIOLAllocation.value.StoreId = Number(QueryStringValue.value.StoreId);

        try {
          let response = await PatientIssueService.CreateIOLAllocation(
            ObjIOLAllocation.value
          );

          console.log(response);
          //response["result"]

          message = response["ErrorInfo"].ErrorCode;

          if (message == null) {
            toast.add({
              severity: "success",
              summary: "Success",
              detail: "saved successfully!",
              life: 3000,
            });

            setTimeout(() => {
              IsClear();
            }, 1500);
          } else {
            console.log(response["ErrorInfo"].ErrorCode);
            toast.add({
              severity: "warn",
              summary: "Warning",
              detail: "somthing went wrong.",
              life: 3000,
            });

            return;
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    const CreateIssue = async () => {
      debugger;
      try {
        let result;
        let StockOutMasterId;
        let StockInMasterId;
        let message;

        CreateIssueObj.value.DocType = "22";

        CreateIssueObj.value.DocDate = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        CreateIssueObj.value.StoreId = Number(QueryStringValue.value.StoreId);
        CreateIssueObj.value.FromStore = Number(QueryStringValue.value.StoreId);
        CreateIssueObj.value.ToStore = DataObj.value.ToStoreId;

        CreateIssueObj.value.BranchId = Number(QueryStringValue.value.BranchId);
        CreateIssueObj.value.FromStoreBranchId = Number(
          QueryStringValue.value.BranchId
        );
        CreateIssueObj.value.ToStoreBranchId = DataObj.value.ToStoreBranchId;

        CreateIssueObj.value.StoreBrMapId = Number(
          QueryStringValue.value.storebranchmapid
        );
        CreateIssueObj.value.FromStoreBrMapId = Number(
          QueryStringValue.value.storebranchmapid
        );
        CreateIssueObj.value.ToStoreBrMapId = DataObj.value.ToStoreBrMapId;

        CreateIssueObj.value.HospitalId = usersData.OrganizationId;

        CreateIssueObj.value.IsDraft = 0;

        CreateIssueObj.value.CreatedBy = usersData.UserId;
        CreateIssueObj.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        CreateIssueObj.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        CreateIssueObj.value.DcDate = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        CreateIssueObj.value.InvoiceDate = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        CreateIssueObj.value.InwardDate = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        // CreateIssueObj.value.PatientId = PatientDetails.value.UIN;
        // CreateIssueObj.value.PatientName = PatientDetails.value.PatientName;

        CreateIssueObj.value.EntityId = 3027;
        CreateIssueObj.value.EntityOperationId = 3027001;
        CreateIssueObj.value.DeptRoleId = rolesData.DeptRoleMapId;

        let ItemArray = await IssueDetals();

        CreateIssueObj.value.StockOutDetailList = ItemArray;
        // CreateIssueObj.value.StockInDetailList = ItemArray;

        result = await PatientIssueService.CreateIOLIssue(CreateIssueObj.value);

        StockOutMasterId = result["result"][0].Id;

        message = result["ErrorInfo"].ErrorCode;

        const ResultList = result["result"][0];

        itemsCopy.value = itemsCopy.value.map((x) => {
          x.StockOutId = StockOutMasterId;
          x.StockOutDetailId = ResultList.StockOutDetailList[0]["Id"];

          return x;
        });

        if (message == null) {
          items.value = [...items.value, ...itemsCopy.value];

          ItemDetailArr.length = 0;
          HiddenItems.value.length = 0;
          itemsCopy.value.length = 0;

          ObjectClear();

          toast.add({
            severity: "success",
            summary: "Success",
            detail: "Added successfully!",
            life: 3000,
          });
        } else {
          console.log(result["ErrorInfo"].ErrorCode);
          toast.add({
            severity: "warn",
            summary: "Warning",
            detail: "somthing went wrong.",
            life: 3000,
          });

          return;
        }
      } catch (error) {
        console.log(error);
      }
    };

    const UpdateStockOutStockIn = async () => {
      debugger;
      if (items.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "No Items Found",
          detail: "Please add at least one item to proceed.",
          life: 3000,
        });

        return;
      } else {
        try {
          let arr: any = [];

          for (let i = 0; i < items.value.length; i++) {
            let obj = {};

            (obj["StockOutId"] = items.value[i]["StockOutId"] || 0),
              arr.push(obj);
          }

          let result = await PatientIssueService.UpdateStockOutStockIn(arr);

          let message = result["ErrorInfo"].ErrorCode;

          if (message == null) {
            toast.add({
              severity: "success",
              summary: "Success",
              detail: "saved successfully!",
              life: 3000,
            });

            setTimeout(() => {
              IsClear();
            }, 1500);
          } else {
            console.log(result["ErrorInfo"].ErrorCode);
            toast.add({
              severity: "warn",
              summary: "Warning",
              detail: "somthing went wrong.",
              life: 3000,
            });

            return;
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    const IssueDetals = () => {
      debugger;
      ItemDetailArr.lenth = 0;

      for (let i = 0; i < itemsCopy.value.length; i++) {
        let obj = {};
        // if (itemsCopy.value[i]["StockOutDetailId"] == 0) {

        (obj["Id"] = itemsCopy.value[i]["StockOutDetailId"] || 0),
          (obj["ItemId"] = itemsCopy.value[i]["ItemId"]),
          (obj["Qty"] = itemsCopy.value[i]["Qty"]),
          (obj["RefId"] = 0),
          (obj["Rate"] = itemsCopy.value[i]["Rate"] || 0.0),
          (obj["UnitRate"] = itemsCopy.value[i]["UnitRate"] || 0.0),
          (obj["PurchaseTax"] = itemsCopy.value[i]["PurchasePercentage"]),
          (obj["PurchaseTaxAmount"] = 0.0),
          (obj["SaleTax"] = 0.0),
          (obj["SaleTaxAmount"] = 0.0),
          (obj["PackSizeId"] = itemsCopy.value[i]["PackageSizeId"] || 0),
          (obj["HSNId"] = itemsCopy.value[i]["HSNId"] || 0),
          (obj["BarCodeNo"] = itemsCopy.value[i]["BarCodeNo"] || 0),
          (obj["BarCode"] = itemsCopy.value[i]["BarCode"] || "");

        obj["RefBarCodeNo"] = itemsCopy.value[i]["BarCodeNo"] || 0;
        obj["RefBarCode"] = itemsCopy.value[i]["BarCode"] || "";

        if (itemsCopy.value[i]["ItemExpiryDate"]) {
          obj["ExpiryDate"] = moment(
            itemsCopy.value[i]["ItemExpiryDate"],
            "DD-MM-YYYY"
          ).format("YYYY-MM-DD");
        } else {
          obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
        }

        // if (items.value[i]["ManufactureDate"]) {
        //     obj["ManufactureDate"] = moment(
        //         items.value[i]["ManufactureDate"],
        //         "DD-MM-YYYY"
        //     ).format("YYYY-MM-DD");
        // } else {
        //     obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
        // }
        if (itemsCopy.value[i]["ManufactureDate"]) {
          obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
        }

        (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
          (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
          (obj["CreatedBy"] = usersData.UserId),
          (obj["ModifiedBy"] = 0),
          (obj["UOM"] = itemsCopy.value[i]["UOM"] || 0),
          (obj["BatchNo"] = itemsCopy.value[i]["Batchno"] || ""),
          (obj["Brand"] = itemsCopy.value[i]["Brand"] || 0),
          (obj["ModelNumber"] = itemsCopy.value[i]["ModelNumber"] || 0),
          (obj["Size"] = itemsCopy.value[i]["Size"] || 0);

        (obj["IsApproved"] = 1),
          (obj["Remarks"] = itemsCopy.value[i]["Remarks"] || ""),
          (obj["PickStartTime"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
          (obj["PickEndTime"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
          (obj["ToStoreUserId"] = DataObj.value.OTSisterId || 0);

        obj["StockInId"] = itemsCopy.value[i]["StockInId"] || 0;

        obj["StockInDetailId"] = itemsCopy.value[i]["StockInDetailId"] || 0;

        (obj["PatientId"] = itemsCopy.value[i]["PatientId"] || ""),
          (obj["PatientName"] = itemsCopy.value[i]["PatientName"] || ""),
          ItemDetailArr.push(obj);
        // }
      }

      return ItemDetailArr;
    };

    const UpdateConsumption = async () => {
      debugger;
      alert("hi");
      const IsSelect = issueditems.value.some(
        (item) => item.StockReasonId == null && item.StockReasonId == undefined
      );

      if (IsSelect) {
        toast.add({
          severity: "warn",
          summary: "warning",
          detail: "Select status for all the items",
          life: 3000,
        });
      } else {
        try {
          let CArr: any = [];
          let result;
          let StockOutMasterId;
          let StockInMasterId;
          let message;

          IssueReturnObj.value.DocType = "";

          IssueReturnObj.value.DocDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          IssueReturnObj.value.StoreId = issueditems.value[0]["ToStore"];
          IssueReturnObj.value.FromStore = issueditems.value[0]["ToStore"];
          IssueReturnObj.value.ToStore = issueditems.value[0]["FromStore"];

          IssueReturnObj.value.BranchId =
            issueditems.value[0]["ToStoreBranchId"];
          IssueReturnObj.value.FromStoreBranchId =
            issueditems.value[0]["ToStoreBranchId"];
          IssueReturnObj.value.ToStoreBranchId =
            issueditems.value[0]["FromStoreBranchId"];

          IssueReturnObj.value.StoreBrMapId =
            issueditems.value[0]["ToStoreBrMapId"];
          IssueReturnObj.value.FromStoreBrMapId =
            issueditems.value[0]["ToStoreBrMapId"];
          IssueReturnObj.value.ToStoreBrMapId =
            issueditems.value[0]["FromStoreBrMapId"];

          IssueReturnObj.value.HospitalId = usersData.OrganizationId;

          IssueReturnObj.value.IsDraft = 0;

          IssueReturnObj.value.CreatedBy = usersData.UserId;
          IssueReturnObj.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          IssueReturnObj.value.ModifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          IssueReturnObj.value.DcDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          IssueReturnObj.value.InvoiceDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          IssueReturnObj.value.InwardDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          IssueReturnObj.value.PatientId = issueditems.value[0]["uin"];
          IssueReturnObj.value.PatientName =
            issueditems.value[0]["patientName"];

          IssueReturnObj.value.Remarks = ObjIOLAllocation.value.Remarks;

          IssueReturnObj.value.EntityId = 3027;
          IssueReturnObj.value.EntityOperationId = 3027001;
          IssueReturnObj.value.DeptRoleId = rolesData.DeptRoleMapId;

          for (let i = 0; i < issueditems.value.length; i++) {
            let obj = {};

            // (obj["Id"] = issueditems.value[i]["StockOutDetailId"] || 0),
            (obj["Id"] = 0),
              (obj["ItemId"] = issueditems.value[i]["ItemId"]),
              (obj["Qty"] = issueditems.value[i]["Qty"]),
              (obj["RefId"] = 0),
              (obj["Rate"] = issueditems.value[i]["Rate"] || 0.0),
              (obj["UnitRate"] = issueditems.value[i]["UnitRate"] || 0.0),
              (obj["PurchaseTax"] = 0.0),
              (obj["PurchaseTaxAmount"] = 0.0),
              (obj["SaleTax"] = 0.0),
              (obj["SaleTaxAmount"] = 0.0),
              (obj["PackSizeId"] = issueditems.value[i]["PackageSizeId"] || 0),
              (obj["HSNId"] = issueditems.value[i]["HSNId"] || 0),
              (obj["BarCodeNo"] = issueditems.value[i]["BarCodeNo"] || 0),
              (obj["BarCode"] = issueditems.value[i]["BarCode"] || "");

            obj["RefBarCodeNo"] = issueditems.value[i]["BarCodeNo"] || 0;
            obj["RefBarCode"] = issueditems.value[i]["BarCode"] || "";

            if (issueditems.value[i]["ItemExpiryDate"]) {
              obj["ExpiryDate"] = moment(
                issueditems.value[i]["ItemExpiryDate"],
                "DD-MM-YYYY"
              ).format("YYYY-MM-DD");
            } else {
              obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
            }

            // if (items.value[i]["ManufactureDate"]) {
            //     obj["ManufactureDate"] = moment(
            //         items.value[i]["ManufactureDate"],
            //         "DD-MM-YYYY"
            //     ).format("YYYY-MM-DD");
            // } else {
            //     obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
            // }

            if (issueditems.value[i]["ManufactureDate"]) {
              obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
            }

            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["CreatedBy"] = usersData.UserId),
              (obj["ModifiedBy"] = 0),
              (obj["UOM"] = issueditems.value[i]["UOM"] || 0),
              (obj["BatchNo"] = issueditems.value[i]["BatchNo"] || ""),
              (obj["Brand"] = issueditems.value[i]["Brand"] || 0),
              (obj["ModelNumber"] = issueditems.value[i]["ModelNumber"] || 0),
              (obj["Size"] = issueditems.value[i]["Size"] || 0);

            (obj["IsApproved"] = 1),
              (obj["Remarks"] = issueditems.value[i]["Remarks"] || ""),
              (obj["PickStartTime"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (obj["PickEndTime"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (obj["ToStoreUserId"] = issueditems.value[i]["ToStoreUserId"]);

            obj["StockInId"] = issueditems.value[i]["StockInId"] || 0;

            obj["StockInDetailId"] =
              issueditems.value[i]["StockInDetailId"] || 0;

            obj["StockReasonId"] = issueditems.value[i]["StockReasonId"];

            CArr.push(obj);
          }

          CreateIssueObj.value.StockOutDetailList = CArr;

          result = await PatientIssueService.UpdateConsumption(
            CreateIssueObj.value
          );

          StockOutMasterId = result["result"][0].Id;

          message = result["ErrorInfo"].ErrorCode;

          if (message == null) {
            toast.add({
              severity: "success",
              summary: "Success",
              detail: "Updated successfully!",
              life: 3000,
            });

            setTimeout(() => {
              IsClear();
            }, 1500);
          } else {
            console.log(result["ErrorInfo"].ErrorCode);
            toast.add({
              severity: "warn",
              summary: "Warning",
              detail: "somthing went wrong.",
              life: 3000,
            });

            return;
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    function IsClear() {
      showIOLDialogvar.value = false;
      emit("closepopup", showIOLDialogvar.value);
    }

    const ObjectClear = () => {
      debugger;
      Object.assign(PatientDetails.value, {
        UIN: "",
        MRNNo: "",
        PatientName: "",
        NextOfKin: "",
        Eye: "",
        Surgery: "",
        Lense: "",
        ExpectedAdmissionDate: null,
        SiteId: 0,
        PatientType: "",
        IolPower: "",
        StockOutId: 0,
        StockInId: 0,
      });

      DataObj.value.OTSisterId = null;

      if (!QueryStringValue.value.StockOutId) {
        DataObj.value.OTDeptId = null;
      }

      DataObj.value.ItemFieldDisabled = true;
    };

    //Scanned Item Fields
    interface ItemList {
      StockOutId: number;
      StockOutDetailId: number;
      PatientId: string;
      ItemProductId: string;
      // ItemId: number;
      ItemName: string;
      // Brand: number;
      BrandName: string;
      // ModelNumber: number;
      ModelNumberName: string;
      // Size: number;
      SizeName: string;
      Qty: number;
      BarCodeNo: number;
      BarCode: string;
      BatchNo: string;
      ItemExpiryDate: string;
    }

    const headers = [
      {
        header: "Department",
        field: "ToStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "UIN",
        field: "PatientId",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "Patient Name",
        field: "PatientName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "User",
        field: "ToStoreUserName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "Code",
        field: "ItemProductId",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "Item Name",
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Model",
        field: "ModelNumberName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Brand",
        field: "BrandName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Size",
        field: "SizeName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "QTY",
        field: "Qty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Lot No",
        field: "BarCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Batch No",
        field: "Batchno",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Expiry Date",
        field: "ItemExpiryDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Remarks",
        field: "Remarks",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td text_overflow2",
        class: "mediumwidth",
      },
    ];

    //Allocated Item Fields
    interface AllocatedItemList {
      ItemProductId: string;
      // ItemId: number;
      ItemName: string;
      // Brand: number;
      BrandName: string;
      // ModelNumber: number;
      ModelNumberName: string;
      // Size: number;
      SizeName: string;
      Qty: number;
      // BarCodeNo: string;
      BarCode: string;
      BatchNo: string;
      ExpiryDate: string;
    }

    const allocatedheaders = [
      {
        header: "Code",
        field: "ItemProductId",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "Item Name",
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Model",
        field: "ModelNumberName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Lens Type",
        field: "BrandName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Diopter Size",
        field: "SizeName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "QTY",
        field: "Qty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Lot No",
        field: "BarCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Batch No",
        field: "BatchNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Expiry Date",
        field: "ExpiryDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
    ];

    //Issued Item Fields
    interface IssuedItemList {
      ItemProductId: string;
      // ItemId: number;
      ItemName: string;
      // Brand: number;
      BrandName: string;
      // ModelNumber: number;
      ModelNumberName: string;
      // Size: number;
      SizeName: string;
      Qty: number;
      // BarCodeNo: string;
      BarCode: string;
      BatchNo: string;
      ItemExpiryDate: string;
      StockReasonId: number;
    }

    const issueheaders = [
      {
        header: "Code",
        field: "ItemProductId",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "boldclass",
      },
      {
        header: "Item Name",
        field: "ItemName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Model",
        field: "ModelNumberName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Lens Type",
        field: "BrandName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Diopter Size",
        field: "SizeName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "QTY",
        field: "Qty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "Lot No",
        field: "BarCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Batch No",
        field: "BatchNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Expiry Date",
        field: "ExpiryDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Remarks",
        field: "Remarks",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td text_overflow2",
        class:
          QueryStringValue.value.Param == "updateconsumption"
            ? "d-none"
            : "mediumwidth",
      },
      {
        header: "Status",
        field: "",
        fieldDisplay: "false",
        slot: "ConsumptionStatus",
        class:
          QueryStringValue.value.Param == "updateconsumption" ? "" : "d-none",
      },
    ];

    const iolheaders = [
      {
        header: "Item Name",
        field: "",
        slot: "ItemName",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: "Brand / Model / Size",
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Batch No",
        field: "Batchno",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
      {
        header: "Expiry Date",
        field: "ExpiryDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "red_td",
      },
    ]


    return {
      // showIOLDialog,
      showIOLDialogvar,
      items,
      allocateditems,
      loading,
      iolLoading,
      headers,
      allocatedheaders,
      SelectOption,
      showitemsvar,
      submitlabel,
      issueditems,
      issueheaders,
      PatientDetails,
      DataObj,
      ObjIOLAllocation,
      onScanEnter,
      LoadItem,
      IsClear,
      IsSubmit,
      RemarksPopUpObj,
      AddRemarks,
      CancelRemarks,
      OTDeptOnChange,
      OTSisterOnChange,
      filterReason,
      ReasonOnChange,
      AddItem,
      datamodel,
      LoadUINNumber,
      UINNumberSelect,
      QueryStringValue,
      ObjectClear,
      chkAllocationPopUpObj,
      CancelAllocation,
      AddAllocation,
      iolitems,
      iolheaders
    };
  },
});
</script>

<style lang="scss">
.patientdetailspopupcard {
  background: #ffffff;
  padding: 10px 15px;
  border-radius: 10px;
  color: #000000;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  margin-bottom: 15px;
  // width: max-content;

  p {
    margin-bottom: 7px;
  }

  span {
    color: #000000;
  }

  .firstdiv {
    display: flex;
    padding: 15px 0px;

    div:nth-child(2) {
      border-left: 1px solid #e1e1e1;
      border-right: 1px solid #e1e1e1;
      padding-inline: 15px;
      margin-inline: 15px;
    }
  }
}

.barcodebg {
  border: 1px solid #999999;
  padding: 5px;
  margin: auto;
  margin-top: 30%;
  width: max-content;
}

.activebarcodebg {
  border: 2px solid blue;
  padding: 5px;
  margin: auto;
  margin-top: 30%;
  width: max-content;
}

.spantxt {
  font-size: 11px;
  color: grey;
}
</style>
